const URL_BASE=process.env.REACT_APP_API;

export const URL_AGENCY_LIST=`${URL_BASE}/agency`;

//https://hmyadminbackprod.ddns.net/api/agency